import React from 'react'

import styles from './DisplayHeading.module.css'

const DisplayHeading: React.FC = ({ children }) => {
  return <h1 className={styles.displayHeading}>{children}</h1>
}

export default DisplayHeading
